import classnames from 'classnames'
import { assign, get, transform } from 'lodash'
import moment from 'moment'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { AuthUserSchema } from 'app'
import { Build, Emoji, Trophy } from 'images'
import { parser } from 'messages'

import RankingTable from 'components/sports/soccer/ranking/RankingTable'

import { platformDataFetch, platformDataFetchCanceled } from '../../actions'
import BackgroundCurve from '../../components/BackgroundCurve'
import HomeBanner from '../../components/HomeBanner'
import InstitutionsList from '../../components/InstitutionsList'
import StatsList from '../../components/StatsList'
import { SWEATBITS_TEXT } from '../../constants'

import styles from './index.css'

class HomeScreen extends PureComponent {
  componentDidMount() {
    this.props.platformDataFetch()
  }

  componentWillUnmount() {
    this.props.platformDataFetchCanceled()
  }

  render() {
    const { institutions, onRegister, stats, time, tournament, viewer } = this.props

    return (
      <div className={styles.wrapper}>
        <HomeBanner className={styles.greyBackground} onRegisterClick={onRegister} showRegister={!viewer} />
        <BackgroundCurve className={styles.greyBackground} />
        <div className={styles.subheader}>
          <h2>La mejor plataforma para jugadores, equipos, torneos e instituciones.</h2>
          <p className={styles.phrase}>
            <b>{SWEATBITS_TEXT}</b> está hecha para compartir y aportar información de encuentros deportivos.
          </p>
        </div>
        <div className={styles.columns}>
          <div>
            <div className={styles.attachedHeader}>
              <div>
                <Emoji name="point_down" /> Esta es la tabla de grupos
              </div>
              <div className="flex flex-wrap items-center gap-2">
                Torneo
                <Link className="flex items-center gap-1" to={`/sports/tournament/${tournament.id}`}>
                  <Trophy size="1.5em" src={get(tournament, 'avatar')} /> {get(tournament, 'name')}
                </Link>
                <Link className="flex items-center gap-1" to={`/institution/${get(tournament, 'institution.id')}`}>
                  <Build size="1.5em" src={get(tournament, 'institution.avatar')} />
                  {get(tournament, 'institution.nickname')}
                </Link>
              </div>
            </div>
            <RankingTable
              className={classnames(styles.raised, styles.scrollable)}
              fairPlay={get(tournament, 'tournament.is_fair_play_active', false)}
              stage={get(tournament, 'tournament.stages[0]')}
              teams={transform(
                get(tournament, 'relevant_teams'),
                (teams, team) => {
                  assign(teams, { [team.id]: team })
                },
                {},
              )}
              teamsStats={get(tournament, 'tournament.teams_stats')}
              tieBreakersOrder={get(tournament, 'tournament.tie_breakers_order')}
            />
          </div>
          <div>
            <h3>
              Resultados de encuentros de <b>inmediato</b>
            </h3>
            <p>
              {parser(
                'Gracias a los *aportes de la comunidad* la información de tablas, marcadores, anotadores, etc. se puede ver en minutos y durante el encuentro.',
              ).render()}
              <br />
              {parser(
                'Ya sea jugador :muscle:, juez :cop: o un observador :eyes: todos pueden cambiar el marcador :success_kid: ',
              ).render()}
              mientras es aprobado por la institución.
            </p>
            <h4>¡Ayúdanos a hacer que el torneo deportivo también sea tuyo!</h4>
            <p>
              <b>{SWEATBITS_TEXT}</b> es una aplicación disponible para todo el mundo que permite seguir, compartir y
              organizar toda la información con respecto a un torneo deportivo; desde los puntos marcados hasta el
              desempeño del juez.
            </p>
          </div>
        </div>
        <div className={classnames(styles.columns, styles.flipped)}>
          <div>
            <div className={styles.attachedHeader}>
              {parser('Algunas instituciones que confían en nosotros: :sunglasses: ').render()}
            </div>
            <InstitutionsList className={classnames(styles.raised, styles.scrollable)} institutions={institutions} />
          </div>
          <div>
            <h3>Somos pequeños pero los grandes confían en nosotros</h3>
            <p>
              Somos un pequeño equipo de personas con una GRAN pasión por el deporte.
              <br />
              <br />
              Todos tenemos conexión con el deporte y una larga trayectoria en soluciones deportivas, hemos estado
              trabajando muy duro para que este proyecto se realice y lograr que intituciones reconocidas nos apoyen.
            </p>
          </div>
        </div>
        <div className={styles.columns}>
          <div>
            <div className={styles.attachedHeader}>
              <div>
                Datos de nuestra herramienta: <Emoji className="text-2xl" name="nerd_face" />{' '}
                <Emoji className="text-2xl" name="100" />
              </div>
              <div>
                {time && (
                  <div className={styles.timeComment}>
                    <sup>*</sup> Información generada: {moment.unix(time).fromNow()}
                  </div>
                )}
              </div>
            </div>
            <StatsList className={styles.raised} stats={stats} />
          </div>
          <div>
            <h3>Sabemos que al deporte aficionado le faltan herramientas</h3>
            <p>
              Que sean eficientes para hacerlo más manejable y más fácil de organizar.
              <br />
              <br />
              Los jugadores tienen dificultades para realizar un seguimiento de sus logros en el campo; los equipos e
              instituciones pasan una gran cantidad de tiempo tratando de verificar y reunir la información para
              organizar los torneos.
              <br />
              <br />
              Creemos que cada encuentro tiene una historia que vale la pena contar y compartir.
            </p>
          </div>
        </div>
      </div>
    )
  }
}

HomeScreen.propTypes = {
  onRegister: PropTypes.func.isRequired,
  platformDataFetch: PropTypes.func.isRequired,
  platformDataFetchCanceled: PropTypes.func.isRequired,

  institutions: PropTypes.array,
  stats: PropTypes.array,
  time: PropTypes.number,
  tournament: PropTypes.object,
  viewer: AuthUserSchema,
}

HomeScreen.defaultProps = {
  institutions: [],
  stats: [],
  time: 0,
  tournament: null,
  viewer: null,
}

export default connect(null, {
  platformDataFetch,
  platformDataFetchCanceled,
})(HomeScreen)
